import {
    MDBListGroup,
    MDBListGroupItem,
} from "mdb-react-ui-kit"
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button, Col, Row } from "../App.styles";
import { useState } from "react";
import { FormAutocomplete, Spinner, Switch, Textarea } from "../common";
import { useUpdateAnswersAdjustmentMutation } from "./Answer.state";

const AdjustmentList = styled(MDBListGroup)(({ theme }) => `
    & + & {
        margin-top: 12px;
    }

    &.striked {
        .list-group-item:not(:first-of-type) {
            text-decoration: line-through;
        }
    }

    .svg-inline--fa {
        color: ${theme.disabledColor};
    }

    .bonus {
        color: ${theme.successColor};
    }

    .penalty {
        color: ${theme.dangerColor};
    }

    .adjustment-list__item {
        flex: 1;
        display: flex;
        align-items: start;
        gap: 6px;
    }

    .form-label__helper {
        display: none;
    }

    ${theme.breakpoints.up('lg')} {
        .form-label__helper {
            display: block;
        }
    }
`)

const AdjustmentItem = styled(MDBListGroupItem)`
    display: flex;
    align-items: start;
    gap: 6px;

    .badge {
        margin-top: 2px;
    }
`

const AdjustmentItemHeader = styled.div(({ theme }) => `
    flex: 1;
    display: block;
    align-items: center;
    justify-content: space-between;

    ${theme.breakpoints.up('lg')} {
        display: flex;
    }

    .btn {
        margin-bottom: 0;
    }

    .adjustment-list__item__action {
        justify-content: start;

        ${theme.breakpoints.up('lg')} {
            justify-content: end;
        }
    }
`)

const AnswerAdjustmentsEdit = (props) => {
    const { t } = useTranslation()
    const {
        answerId,
        id: adjustmentId, comment, summary, decremental,
        points, correct, greatness, impacts_leaderboard,
        onCancel,
    } = props
    const [value, setValue] = useState({
        id: adjustmentId,
        correct,
        greatness,
        comment,
        summary,
        points,
        decremental,
    })
    const { mutateAsync: updateAdjustment, isLoading: isUpdatingAdjustment } = useUpdateAnswersAdjustmentMutation({ answerId })
    const useQuery = () => [value, (updated) => {
        setValue({
            ...value,
            ...updated,
        })
    }]

    return (
        <AdjustmentList id={adjustmentId} className={impacts_leaderboard ? '' : 'striked'}>
            <AdjustmentItem>
                <AdjustmentItemHeader>
                    <div className="adjustment-list__item">
                        <Row className="flex-grow-1">
                            <Col size="6">
                                <Switch
                                    label={t("Correct")}
                                    labels={{ on: "Yes", off: "No" }}
                                    on={true}
                                    off={false}
                                    value={value?.correct}
                                    name={'correct'}
                                    useQuery={useQuery}
                                />
                            </Col>
                            <Col size="6">
                                <div className="flex-grow-1">
                                    <label class="form-label form-label__helper">&nbsp;</label>
                                    <FormAutocomplete
                                        label={t("Greatness")}
                                        defaultValue={value?.greatness}
                                        options={[
                                            ...Array.from(Array(500).keys()).map(i => ({
                                                id: i + 1,
                                                name: String(i + 1),
                                            })),
                                        ]}
                                        size="small"
                                        name="greatness"
                                        useQuery={useQuery}
                                        creatable
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="adjustment-list__item adjustment-list__item__action">
                        <Button size="sm" className="btn--flat btn--flat-sm d-block" color="secondary" onClick={onCancel}>
                            {t('Cancel')}
                        </Button>
                        <Button size="sm" className="btn--flat btn--flat-sm d-block" onClick={() => {
                            const payload = {...value}
                            payload.correct = payload.correct ? 1 : 0
                            payload.decremental = payload.decremental ? 1 : 0
                            updateAdjustment(payload)
                        }}>
                            {t('Update')} {isUpdatingAdjustment && <Spinner size="0.875rem" />}
                        </Button>
                    </div>
                </AdjustmentItemHeader>
            </AdjustmentItem>
            <AdjustmentItem>
                <Textarea
                    label={t("Comment")}
                    name="comment"
                    useQuery={useQuery}
                    mode="clean"
                    rows="2"
                />
            </AdjustmentItem>
            <AdjustmentItem>
                <Textarea
                    label={t("Summary")}
                    name="summary"
                    useQuery={useQuery}
                    mode="clean"
                    rows="2"
                />
            </AdjustmentItem>
            <AdjustmentItem>
                <Row className="flex-grow-1">
                    <Col size="6" lg="3">
                        <Switch
                            label={t("Decremental")}
                            labels={{ on: "Yes", off: "No" }}
                            on={true}
                            off={false}
                            value={value?.decremental}
                            name={'decremental'}
                            useQuery={useQuery}
                        />
                    </Col>
                    <Col size="6" lg="3">
                        <FormAutocomplete
                            label={t("Points")}
                            defaultValue={value?.points}
                            options={[
                                ...Array.from(Array(500).keys()).map(i => ({
                                    id: i + 1,
                                    name: String(i + 1),
                                })),
                            ]}
                            size="small"
                            name="points"
                            useQuery={useQuery}
                            creatable
                        />
                    </Col>
                </Row>
            </AdjustmentItem>
        </AdjustmentList>
    )
}

export default AnswerAdjustmentsEdit